module.exports = __webpack_public_path__ + "img/fm-f-Path 54 Copy@3x.1c6e1393.png";